// extracted by mini-css-extract-plugin
export default {"scopeItem":"ScopesList_scopeItem__ClEzA"};